(function () {
  'use strict';

  angular
    .module('missingPatternsReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('missingPatternsReport', {
        url: '/missing-patterns-report',
        views:{
            'missingPatternsReportView':{
              templateUrl: 'missing-patterns-report/views/missing-patterns-report.tpl.html',
              controller: 'MissingPatternsReportCtrl',
              controllerAs: 'missingPatternsReport'
            }
        }
      });
  }
}());
